var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kb-image-overlay"},[_vm._t("default",function(){return [(_vm.subtitle)?_c('h2',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }